import React from 'react'
// import EncounterDetails from './TemplateView/EncounterDetails/EncounterDetails'
import TemplateView from './TemplateView/TemplateView'

const EncounterRightPortion = ({
  // searchParam,setSearchParam,
  templateDataToApply, setTemplateDataToApply, ...props}) => {
  return (
    <>
      {/* <EncounterDetails searchParam={searchParam} setSearchParam={setSearchParam} /> */}
      <TemplateView 
      // NoteType={searchParam.NoteType}
       templateDataToApply={templateDataToApply} setTemplateDataToApply={setTemplateDataToApply}
       {...props}
      //  searchParam={searchParam} setSearchParam={setSearchParam}
       />
    </>
  )
}

export default EncounterRightPortion